import { resolveCategory } from './validator-category';
export interface FeeData {
  category?: string;
  category_name?: string;
  currency: string;
  value: number | string;
  created_at?: string;
  [key: string]: any;
}

export interface NormalizedFee {
  category: string;
  category_name: string;
  currency: string;
  value: number | string;
  created_at?: string;
  displayName: string;
  [key: string]: any;
}

export function normalizeFee(fee: FeeData): NormalizedFee {
  const normalized = { ...fee } as NormalizedFee;

  const value = resolveCategory(fee.category, fee.category_name);
  normalized.category = value;
  normalized.category_name = value;
  normalized.displayName = value;
  return normalized;
}

export function normalizeFees(fees: FeeData[]): NormalizedFee[] {
  if (!Array.isArray(fees)) return [];
  return fees.map(normalizeFee);
}

export function normalizeFeesObject(
  feesObject: Record<string, FeeData[]>
): Record<string, NormalizedFee[]> {
  if (!feesObject || typeof feesObject !== "object") return {};
  const normalized: Record<string, NormalizedFee[]> = {};
  for (const [groupName, feeList] of Object.entries(feesObject)) {
    normalized[groupName] = normalizeFees(feeList);
  }
  return normalized;
}

export function getFeeDisplayName(fee: FeeData): string {
  return normalizeFee(fee).displayName;
}
